export function deobfuscate(encoded) {
  return encoded.split('').reverse().join('');
}

export function mailtoHref(email) {
  return String.fromCharCode(109, 97, 105, 108, 116, 111, 58) + email;
}

export const CONTACT = {
  email: deobfuscate('moc.liamg@azneamydna'),
  phone: deobfuscate('5145662970'),
  phoneDisplay: deobfuscate('5145 662 970'),
  waNumber: deobfuscate('51456629772'),
};
